import React from "react";
import { getInitials } from "../../lib/util";
import ImageComponent from "./ImageComponent";

const InitialCard = ({ image, name }) => {
  const containerStyle = {
    display: "flex",
    justifyContent: "center", // Horizontally center the image
    height: "50px", // Set a height for the container
    width: "50px", // Set the width of the container
    border: "1px solid #ccc", // Optional: visual border for the container
    overflow:"hidden",
    borderRadius: '50%',  
  };
  const imageStyle = {
    width: "100%", // Ensure the image scales within the container
   // maxHeight: "100%", // Maintain aspect ratio and prevent overflow
    objectFit: "cover", // Keep the image contained within the boundaries
  };
  return (
    <>
      {image ? (
        <div style={containerStyle}>
          <ImageComponent src={image} style={imageStyle} quality={100} />
        </div>
      ) : (
        <div className="initial-base">
          <div className="label">{getInitials(name, 1)}</div>
        </div>
      )}
    </>
  );
};

export default InitialCard;
